module.exports = __webpack_public_path__ + "static/media/bsg-design.3106d043.png";